import React, { Component } from 'react';

import Property from './Property';
import CreateItem from '../../../../Common/Partials/CreateItem';

type Props = {
  addItemLabel: string,
  fields: any,
  mainLabel: string,
  record: any
};

class Properties extends Component<Props> {
  handleRemove = (e, index) => {
    this.props.fields.remove(index);
  }

  render() {
    return (
      <div>
        <div style={{ fontWeight: 'bold' }}>{this.props.mainLabel}</div><br />
        {this.props.fields.length > 0 && this.props.fields.map((item, index) => {
          return (
            <div key={index}>
              <Property index={index} item={item} record={this.props.record} handleRemove={this.handleRemove} /><br />
            </div>
          )
        })}
        <div style={{ paddingTop: 5 }}>
          <CreateItem fields={this.props.fields} label={this.props.addItemLabel} />
        </div><br />

        * Zero Options - free form input<br />
        * One Option - display read-only text<br />
        * Multiple Options - dropdown selection
      </div>
    )
  }
};

export default Properties;



// WEBPACK FOOTER //
// ./src/views/Components/Managed/PropertyGroups/Partials/Properties.tsx